import { PhoneSearchResult } from 'model/PhoneSearch';

export interface PhoneSearchState {
    results: Array<PhoneSearchResult>;
    status: PhoneSearchStatus;
    loading: boolean;
    error: string | undefined;
}

export enum PhoneSearchStatus {
    Initial,
    Searching,
    SearchingSuccess,
    Error
}
